export default __webpack_public_path__ + "static/media/NSPA.5a07ef11.jpeg";